import posthog from "posthog-js";

// Meta Pixel Helper Functions
const fbq = (...args) => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq(...args);
  }
};

/**
 * Track event to PostHog and Meta Pixel
 * @param {string} eventName - Event name
 * @param {object} params - Event parameters
 */
const trackEvent = (eventName, params = {}) => {
  posthog.capture(eventName, params);
  fbq("trackCustom", eventName, params);
};

// Game Events
export const trackGameStart = (gameName, provider) => {
  trackEvent("game_start", {gameName, provider});
};

// User Events
export const trackUserRegistration = userId => {
  posthog.capture("user_registered", {userId});
  fbq("track", "CompleteRegistration", {userId});
};

export const trackUserLogin = userId => {
  trackEvent("user_login", {userId});
};

// Purchase/Transaction Events
export const trackRaffleTicketPurchase = (raffleId, numberOfTickets) => {
  trackEvent("raffle_ticket_purchase", {raffleId, numberOfTickets});
};

export const trackPurchase = (value, currency = "VES", contentName = "") => {
  posthog.capture("purchase", {value, currency, content_name: contentName});
  fbq("track", "Purchase", {value, currency, content_name: contentName});
};

// Deposit/Withdrawal Events
export const trackDepositButtonClick = () => {
  trackEvent("deposit_button_clicked", {});
};

export const trackDepositButtonMenuClick = () => {
  trackEvent("deposit_button_menu_clicked", {});
};

export const trackDeposit = (amount, currency = "VES", method = "") => {
  posthog.capture("deposit_completed", {amount, currency, payment_method: method});
  fbq("trackCustom", "DepositCompleted", {amount, currency, payment_method: method});
};

export const trackWithdrawal = (amount, currency = "VES", method = "") => {
  trackEvent("withdrawal_completed", {amount, currency, payment_method: method});
};

// Add to Cart / Wishlist
export const trackAddToCart = (contentName, value, currency = "VES") => {
  posthog.capture("add_to_cart", {content_name: contentName, value, currency});
  fbq("track", "AddToCart", {content_name: contentName, value, currency});
};

export const trackAddToWishlist = contentName => {
  posthog.capture("add_to_wishlist", {content_name: contentName});
  fbq("track", "AddToWishlist", {content_name: contentName});
};

// Search Event
export const trackSearch = (searchQuery, contentCategory = "") => {
  posthog.capture("search", {search_string: searchQuery, content_category: contentCategory});
  fbq("track", "Search", {search_string: searchQuery, content_category: contentCategory});
};

// View Content Event
export const trackViewContent = (contentName, contentType = "", contentId = "") => {
  const params = {
    content_name: contentName,
    content_type: contentType,
    content_ids: contentId ? [contentId] : [],
  };
  posthog.capture("view_content", params);
  fbq("track", "ViewContent", params);
};

// Lead Event
export const trackLead = (contentName = "") => {
  posthog.capture("lead_generated", {content_name: contentName});
  fbq("track", "Lead", {content_name: contentName});
};
